<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="iconLeft" :disabled="loading" :label="$lang.iconLeft" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconRight" :disabled="loading" :label="$lang.iconRight" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="block" :label="$lang.block" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="flat" :label="$lang.flat" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="plain" :label="$lang.plain" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="loading" :label="$lang.loading" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="outlined" :label="$lang.outlined" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="active" :label="$lang.active" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="fancy" :label="$lang.fancy" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card align="center">
          <card-text :class="['p-4']">
            <btn :plain="plain" :active="active" :fancy="fancy" :outlined="outlined" :rounded="rounded" :disabled="disabled" :elevation="flat ? 'none' : 'md'" :loading="loading" :icon-left="iconLeft ? 'home' : null" :icon-right="iconRight ? 'account' : null" :block="block">{{ $lang.defaultButton }}</btn>
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="24">
        <h-three title="Icon Button" />
        <card align="center">
          <card-text :class="['p-4']">
            <btn :icon="button.icon" :class="['mx-1']" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" v-for="(button, index) in buttons" :key="index" @click="log('click', 'btn', button.icon)" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="24">
        <h-three :title="$lang.buttonSizes" />
        <card align="center">
          <card-text :class="['p-4']">
            <btn color="white" :class="['mx-2']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" v-for="(button, index) in buttons" :key="index" :size="button.size" @click="log('click', 'btn', button.size)">{{ button.size }}</btn>
          </card-text>
        </card>
        <card align="center" :class="['mt-4']">
          <card-text>
            <btn color="white" icon-left="star" :class="['mx-1']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" v-for="(button, index) in buttons" :key="index" :size="button.size" @click="log('click', 'btn', button.size)">{{ button.size }}</btn>
          </card-text>
        </card>
        <card align="center" :class="['mt-4']">
          <card-text :class="['p-4']">
            <btn color="white" icon-right="star" :class="['mx-1']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" v-for="(button, index) in buttons" :key="index" :size="button.size" @click="log('click', 'btn', button.size)">{{ button.size }}</btn>
          </card-text>
        </card>
        <card align="center" :class="['mt-4']">
          <card-text :class="['p-4']">
            <btn color="white" icon="star" :class="['mx-1']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" v-for="(button, index) in buttons" :key="index" :size="button.size" @click="log('click', 'btn', button.size)" />
          </card-text>
        </card>
      </flex-col>
    </flex>
    <flex-col :span="24">
      <h-three :title="$lang.linkButton" />
      <card align="center">
        <card-text>
          <btn color="white" icon-right="open-in-new" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" tag="a" :href="$root.config.companyWebsite.replace('bitbucket.', '')" target="_blank">{{ $lang.goToBrandCompete }}</btn>
        </card-text>
      </card>
    </flex-col>
    <flex-col :span="24">
      <h-three :title="$lang.routerLinkButton" />
      <card align="center">
        <card-text>
          <btn color="white" icon-left="home" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" tag="router-link" to="/ui">{{ $lang.home }}</btn>
        </card-text>
      </card>
    </flex-col>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBtn',
  mixins: [
    methods
  ],
  data () {
    return {
      fancy: false,
      flat: false,
      plain: false,
      outlined: false,
      rounded: true,
      block: false,
      loading: false,
      iconLeft: false,
      iconRight: false,
      disabled: false,
      active: false,
      buttons: []
    }
  },
  watch: {
    fancy () {
      if (this.fancy) {
        this.rounded = false
      }
    },
    rounded () {
      if (this.rounded) {
        this.fancy = false
      }
    }
  },
  mounted () {
    this.getExternalData('btn.json', 'buttons')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/btn.vue